import React, { Dispatch, SetStateAction } from 'react';
import {
  View, StyleSheet, Text, Pressable,
} from 'react-native';
import Colors from '../../../../../constants/Colors';
import FloorIcon from '../../../../../components/16pxIcons/FloorIcon';
import CheckBox from '../../../../../components/16pxIcons/CheckBox';
import ConnectorIcon from '../../../../../components/ConnectorIcon';

interface BuildingLayoutProps {
  areasCanContainAssets: boolean,
  spacesCanContainAssets: boolean,
  setAreasCanContainAssets: Dispatch<SetStateAction<boolean>>,
  setSpacesCanContainAssets: Dispatch<SetStateAction<boolean>>,
}

const CanContainAssetsLabel = () => <Text
  style={styles.canContainAssetsText}
  selectable={false}
>
  {'Can contain assets'}
</Text>;

const BuildingLayout = ({
  areasCanContainAssets, spacesCanContainAssets, setAreasCanContainAssets,
  setSpacesCanContainAssets,
}: BuildingLayoutProps) => <View style={styles.layoutSection}>
    <Text style={styles.subTitle}>{'Building layout'}</Text>
    <View style={styles.layoutSubSection}>
      <View style={styles.floorTitleSection}>
        <FloorIcon fill={Colors.light.hereworksDarkBlue} />
        <Text style={styles.floorTitle}>{'Floor'}</Text>
      </View>
      <View style={styles.checkBoxSection}>
        <Pressable
          disabled
          style={{ opacity: 0.3 }}
          testID='lm-floor-check-box'
        >
          <CheckBox checkcolor={Colors.light.hereworksBlue500} />
        </Pressable>
        <CanContainAssetsLabel />
      </View>
    </View>
    <View style={styles.areaSectionWrapper}>
      <ConnectorIcon />
      <View style={[styles.layoutSubSection, styles.areaSection]}>
        <Text style={styles.areaTitle}>{'Area'}</Text>
        <View style={styles.checkBoxSection}>
          <Pressable
            style={styles.row}
            onPress={() => setAreasCanContainAssets(!areasCanContainAssets)}
            testID='lm-area-check-box'
          >
            {areasCanContainAssets ? <CheckBox checkcolor={Colors.light.hereworksBlue500} />
              : <View style={styles.checkBoxUnselected} />}
            <CanContainAssetsLabel />
          </Pressable>
        </View>
      </View>
    </View>
    <View style={styles.spaceSectionWrapper}>
      <ConnectorIcon />
      <View style={[styles.layoutSubSection, styles.areaSection]}>
        <Text style={styles.areaTitle}>{'Space'}</Text>
        <View style={styles.checkBoxSection}>
          <Pressable
            style={styles.row}
            onPress={() => setSpacesCanContainAssets(!spacesCanContainAssets)}
            testID='lm-space-check-box'
          >
            {spacesCanContainAssets
              ? <CheckBox checkcolor={Colors.light.hereworksBlue500} />
              : <View style={styles.checkBoxUnselected} />}
            <CanContainAssetsLabel />
          </Pressable>
        </View>
      </View>
    </View>
  </View>;

const styles = StyleSheet.create({
  layoutSection: {
    flex: 0.5,
  },
  subTitle: {
    fontSize: 20,
    lineHeight: 30,
    fontFamily: 'Poppins_500Medium',
    color: Colors.light.hereworksBlack600,
    marginBottom: 27,
  },
  layoutSubSection: {
    borderRadius: 10,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue100,
    backgroundColor: Colors.light.hereworksWhite100,
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  floorTitleSection: {
    flexDirection: 'row',
    borderBottomColor: Colors.light.hereworksBlue100,
    borderBottomWidth: 1,
    paddingBottom: 8,
    marginBottom: 12,
    alignItems: 'center',
  },
  floorTitle: {
    fontSize: 20,
    lineHeight: 25,
    fontFamily: 'Poppins_500Medium',
    color: Colors.light.hereworksBlack600,
    marginStart: 12,
  },
  checkBoxSection: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  checkBoxUnselected: {
    borderRadius: 4,
    width: 16,
    height: 16,
    borderWidth: 1,
    borderColor: Colors.light.hereworksBlue100,
    backgroundColor: Colors.light.hereworksWhite100,
  },
  canContainAssetsText: {
    fontSize: 14,
    lineHeight: 21,
    fontFamily: 'Poppins_500Medium',
    color: Colors.light.hereworksBlack600,
    marginStart: 8,
  },
  areaTitle: {
    fontSize: 16,
    lineHeight: 20,
    fontFamily: 'Poppins_500Medium',
    color: Colors.light.hereworksBlack600,
    marginBottom: 12,
  },
  areaSectionWrapper: {
    marginStart: 8,
    flexDirection: 'row',
  },
  areaSection: {
    marginTop: 8,
    alignSelf: 'flex-start',
    flex: 1,
    marginBottom: 0,
  },
  spaceSectionWrapper: {
    flexDirection: 'row',
    marginStart: 24,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
  },
});

export default BuildingLayout;
